export default {
  props: {
    open: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    visible: {
      get () {
        return this.open
      },
      set (v) {
        this.$emit('update:open', v)
      }
    }
  },
  methods: {
    closeModal () {
      this.$store.dispatch('GlobalStore/modalClosed')
      this.$emit('closeModal')
      this.visible = false
    }
  },
  created () {
    this.$store.dispatch('GlobalStore/modalOpened')
  },
  activated () {
    this.$store.dispatch('GlobalStore/modalOpened')
  }
}
